export const ACTION_KEYS = {
  lock_credentials: 'app.device.actions.lock_credentials',
  autopilot_reset: 'app.device.actions.autopilot_reset',
  retrieve_bitlocker: 'app.device.actions.retrieve_bitlocker',
  wipe: 'app.device.actions.wipe',
  fresh_start: 'app.device.actions.fresh_start',
  bitlocker_keys: 'app.device.actions.bitlocker_keys.bitlocker_retrieved',
  key_retrieved: 'app.device.actions.bitlocker_keys.key_retrieved',
  error_title: 'app.device.actions.error_title',
  request_failed: 'app.device.actions.request_failed',
} as const;
